import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["radio", "cardCollection", "cardElement", "useDifferentCard", "cardCollectionForm", "replaceCard", "errors", "submitButton"]

    connect() {
        this.stripe = Stripe(document.querySelector("meta[name='stripe-key']").content)
        this.elements = this.stripe.elements()
        this.card = this.elements.create('card', { style: { base: { fontSize: '16px', color: '#32325d' } } })
        this.cardMounted = false
        this.toggleCardCollection()
    }

    toggleCardCollection() {
        const selected = this.radioTargets.find((radio) => radio.checked)
        const needsCard = selected && (selected.value === 'full' || selected.value === 'monthly')
        if (needsCard) {
            this.cardCollectionTarget.classList.remove('d-none')
            // Mount only once the container is actually visible — Stripe
            // Elements mounted into a display:none ancestor often render at
            // 0 size and don't recover just from toggling a class afterward.
            // When cardCollectionForm exists (the "card on file" case), the
            // card element is nested inside it and stays hidden until
            // useDifferentCard reveals it — mount there instead.
            if (this.hasCardElementTarget && !this.cardMounted && !this.hasCardCollectionFormTarget) {
                this.card.mount(this.cardElementTarget)
                this.cardMounted = true
            }
        } else {
            this.cardCollectionTarget.classList.add('d-none')
        }
    }

    useDifferentCard(event) {
        event.preventDefault()
        this.cardCollectionFormTarget.classList.remove('d-none')
        this.replaceCardTarget.value = 'true'
        this.useDifferentCardTarget.classList.add('d-none')
        if (this.hasCardElementTarget && !this.cardMounted) {
            this.card.mount(this.cardElementTarget)
            this.cardMounted = true
        }
    }

    submit(event) {
        const selected = this.radioTargets.find((radio) => radio.checked)
        const needsCard = selected && (selected.value === 'full' || selected.value === 'monthly')
        const alreadyHasCard = this.hasReplaceCardTarget && this.replaceCardTarget.value === 'false'

        if (!needsCard || alreadyHasCard) {
            return
        }

        event.preventDefault()
        if (this.hasSubmitButtonTarget) { this.submitButtonTarget.disabled = true }

        this.stripe.confirmCardSetup(this.data.get("clientSecret"), {
            payment_method: { card: this.card }
        }).then((result) => {
            if (result.error) {
                this.errorsTarget.textContent = result.error.message
                this.errorsTarget.classList.remove('d-none')
                if (this.hasSubmitButtonTarget) { this.submitButtonTarget.disabled = false }
            } else {
                const paymentMethodId = result.setupIntent.payment_method
                fetch(this.data.get("savePaymentMethodUrl"), {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify({ payment_method_id: paymentMethodId })
                }).then((response) => {
                    if (response.ok) {
                        this.element.submit()
                    } else {
                        this.errorsTarget.textContent = 'Could not save your card — please try again.'
                        this.errorsTarget.classList.remove('d-none')
                        if (this.hasSubmitButtonTarget) { this.submitButtonTarget.disabled = false }
                    }
                })
            }
        })
    }
}